import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import './ContentStyle.css';
import ApiSender from '../common/ApiLogic';

function FailedPage() {

  const location = useLocation();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);

  useEffect(() => {
    async function begin() {
      const apiSender = new ApiSender();
      apiSender.sendLogs("failed", params);
    }
    begin();
  }, []);

  const redirectToSms = () => {
    const phoneNumber = '27806';
    const message = 'PLAY';
    const uri = `sms:${phoneNumber}?body=${encodeURIComponent(message)}`;
    window.location.href = uri;
  };

  return (
    <div className="Aa000">
      <div className='container'>
        <div className='header'>
          <div className='logo'><img alt='GameLand' src='%PUBLIC_URL%/../../gameland-logo.png' /></div>
        </div>
        <div className='form-content'>
          <div className='form-content-top'>
            <div className='logo'><img alt='GameLand' src='%PUBLIC_URL%/../../gameland-banner.png' /></div>
          </div>
          <div className='title'>
            <h4>Failed, try again</h4>
          </div>
          <div className='button'>
            <button onClick={redirectToSms}>Try again</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FailedPage;